<template>
	<base-modal :show="!!error" title="An error occurred" @close="handleError">
		<p>{{ error }}</p>
	</base-modal>
	<base-loader :show="isLoading">
	</base-loader>
	<base-modal :show="complete" title="Thank You">
		<button class="btn btn-outline-info" @click="logout">Close</button>
	</base-modal>
	<div class="container">
		<div class="card mt-5 text-info" style="background-color: #263238">
			<div class="card-body">
				<h5 class="card-title">
					<i
						class="fa-solid fa-baseball fa-spin"
						style="--fa-animation-duration: 0.7s"
					></i>
					{{ progressTitle }}
				</h5>
				<div class="progress" style="height: 20px; background-color: #263238">
					<div
						class="progress-bar bg-info text-dark progress-bar-animated"
						role="progressbar"
						:style="{ width: progressBarCalc(stepComplete) }"
						aria-valuenow="25"
						aria-valuemin="0"
						aria-valuemax="100"
					>
						<b>Step {{ stepComplete }}</b>
					</div>
				</div>
			</div>
		</div>
		<div v-if="stepComplete === 1">
			<sign-up-form
				@signup-form-data="storeUserEmail"
				@signup-step-complete="stepCompleted"
			></sign-up-form>
		</div>
		<div v-if="stepComplete === 2">
			<league-add-form
				@league-step-complete="stepCompleted"
				@league-data="storeLeagueInfo"
				:userData2="userInfo"
			></league-add-form>
		</div>
		<div v-if="stepComplete === 3">
			<team-add-form
				:userData3="userInfo"
				:stepComplete="stepComplete"
				@team-step-complete="stepCompleted"
				@user-team="storeTeamInfo"
			></team-add-form>
		</div>
		<div v-if="stepComplete === 4">
			<user-info-form
				@user-info-step-complete="stepsAreCompleted"
				@user-info="storeUserInfo"
				:userData1="userInfo"
			></user-info-form>
		</div>
	</div>
</template>

<script>
import SignUpForm from '@/components/auth/SignUpForm.vue';
import UserInfoForm from '@/components/auth/UserInfoForm.vue';
import LeagueAddForm from '@/components/auth/LeagueAddForm.vue';
import TeamAddForm from '@/components/auth/TeamAddForm.vue';

export default {
	components: {
		SignUpForm,
		UserInfoForm,
		LeagueAddForm,
		TeamAddForm,
	},
	data() {
		return {
			stepComplete: 1,
			componentKey: 0,
			signUpData: null,
			leagueData: null,
			userInfo: {
				firstName: '',
				lastName: '',
				userType: '',
				league: '',
				leagueId: '',
				divisionId: '',
				division: '',
				team: '',
				teamId: '',
				email: '',
			},
			error: null,
			isLoading: false,
			complete: false,
		};
	},
	computed: {
		isAuth() {
			return this.$store.getters.isAuthenticated;
		},
		progressTitle() {
			if (this.stepComplete === 1) {
				return 'Single';
			}
			if (this.stepComplete === 2) {
				return 'Double';
			}
			if (this.stepComplete === 3) {
				return 'Triple';
			} else {
				return 'HomeRun';
			}
		},
		getTeam() {
			return this.$store.getter.userTeam;
		},
	},
	methods: {
		storeUserEmail(payload) {
			this.userInfo.email = payload.email;
		},
		storeUserInfo(payload) {
			this.userInfo.firstName = payload.firstName;
			this.userInfo.lastName = payload.lastName;
			this.userInfo.userType = payload.userType;
			this.submitUserData();
		},
		storeLeagueInfo(payload) {
			console.log(payload)
			if (payload.league.league === '') {
				this.userInfo.league = '';
			}
			this.userInfo.league = payload.league.league;
			this.userInfo.leagueId = payload.leagueId;
			this.userInfo.divisionId = payload.divisionId,
			this.userInfo.division = payload.division.division
		},
		storeTeamInfo(payload) {
			this.userInfo.team = payload.team;
			this.userInfo.teamId = payload.teamId
		},
		async submitUserData() {
			console.log(this.userInfo)
			try {
				await this.$store.dispatch('userInfo', this.userInfo);
			} catch (error) {
				this.error = error.message;
			}
			this.$store.dispatch('fetchUserData');
			this.$store.dispatch('fetchUsers');
		},
		stepCompleted(payload) {
			this.stepComplete += 1;
		},
		stepsAreCompleted(payload) {
			this.stepComplete = 1;
			this.complete = true;
			this.loadSchedules();
			this.loadTeams();
			this.loadUsers();
			this.loadDivisions();
		},
		progressBarCalc(step) {
			const total = 4;
			return (step / total) * 100 + '%';
		},
		handleError() {
			this.error = null;
		},
		async loadSchedules() {
			try {
				this.isLoading = true;
				await this.$store.dispatch('leagues/fetchSchedules');
			} catch (error) {
				this.error = error.message || 'Something failed!';
			}
			this.isLoading = false;
		},
		async loadDivisions() {
			try {
				await this.$store.dispatch('leagues/fetchDivisions');
			} catch (error) {
				this.error = error.message;
			}
		},
		async loadTeams() {
			try {
				this.isLoading = true;
				await this.$store.dispatch('teams/fetchTeams');
			} catch (error) {
				this.error = error.message || 'Something failed!';
			}
			this.isLoading = false;
		},
		async loadUsers() {
			try {
				this.isLoading = true;
				await this.$store.dispatch('fetchUsers');
			} catch (error) {
				this.error = error.message || 'Something failed!';
			}
			this.isLoading = false;
		},
		logout() {
			this.$store.dispatch('logout')
			this.$router.push('/')
			setTimeout(() => {
				this.$router.go()
			},500)
		}
	},
};
</script>
